import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { HiX } from 'react-icons/hi';
import TextInput from '@components/forms/TextInput';
import TextArea from '@components/forms/TextArea';
import AlertBox from '../../../components/ui/AlertBox';
import { useTopics } from '../../../contexts/TopicContext';
import CourseSelectInput from '../../../components/forms/CourseSelectInput';
import { toast } from 'sonner';
import ImageDropBox from '../../../components/forms/ImageDropBox';
import Button from '../../../components/ui/Button';

const TopicModal = ({ isOpen, onClose, currentTopic }) => {

  const { addTopic, editTopic } = useTopics();
  const { register, handleSubmit, reset, setError, setValue, watch,
    formState: { errors, isSubmitting } 
  } = useForm();
  const [submitError, setSubmitError] = useState(null);

  // Watch the image field for preview
  const image = watch('image', currentTopic?.image || null);

  useEffect(() => {
    if (currentTopic) {
      reset({ ...currentTopic, image: currentTopic.image || null });
    } else {
      reset({
        code: '',
        title: '',
        description: '',
        image: null,
      });
    }
  }, [currentTopic, reset]);

  const onSubmit = async (data) => {
    try {
      // Remove image if empty or null
      const payload = { ...data };
      if (!payload.image) delete payload.image;

      if (currentTopic) {
        await editTopic(currentTopic.id, payload);
        toast.success('Topic updated successfully');
        onClose();
      } else {
        await addTopic(payload);
        toast.success('Topic added successfully');
      }
      reset()
      onClose();
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        console.log(errorData)
        Object.keys(errorData).forEach((field) => {
          setError(field, { type: 'server', message: errorData[field][0] });
        })
      } else {
        console.log('i know i got here')
        setSubmitError('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box">
        <label className="absolute right-4 top-4">
          <HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </label>
        <h3 className="font-semibold text-lg mb-4">{currentTopic ? "Edit Topic" : "Add New Topic"}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {submitError && <AlertBox message={submitError} type="error" />  }
          {/* Drag and Drop Image Upload */}
          <ImageDropBox
            value={image}
            onChange={file => setValue('image', file)}
            className="mb-4"
            label="Drag & drop an image here, or click to select"
            previewClass="max-h-32 rounded border mb-2"
          />
          <TextInput
            label="Topic Title"
            name="title"
            type="text"
            placeholder="e.g., Introduction to Computer Science"
            register={register}
            errors={errors}
            validationRules={{ required: 'Topic title is required' }}
          />
          <TextArea
            label="Description"
            name="description"
            placeholder="Enter topic description"
            register={register}
            errors={errors}
            validationRules={{ required: 'Topic description is required' }}
          />
          <CourseSelectInput
            name="course"
            register={register}
            errors={errors}
          />
          <div className="modal-action">
            <Button isLoading={isSubmitting}>
              {currentTopic ? "Update" : "Create"} Topic
            </Button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}>
        <button className="">Close</button>
      </div>
    </div>
  );
};

export default TopicModal;
